<template>
  <div class='memberShare'>
      <img src="@/assets/img/mine/share.png" class="imgs">
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    },
    methods: {},
  }
</script>
<style lang="scss" >
.memberShare{
  background: #f5f5f5;
  width: 100%;
  height:100%;
  font-size: .14rem;
  display: flex;
  justify-content: center;
  align-items: center;
  .imgs{
    width: 80%;
    max-width: 600px;
  }
}

</style>